export default {
  headerContent: {
    title: 'HDI Sigorta Tamamlayıcı Sağlık Sigortası Teklifi',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'HDI Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Tamamlayıcı sağlık sigortası SGK ile anlaşmalı özel hastanelerde katılım payı hariç ücret ödemeden sağlık hizmeti alınmasını sağlamaktadır.',
        'Siz ve aileniz için ne tür bir sağlık sigortasının en iyisi olduğuna karar verirken, istediğiniz plan türüne karar vermeden önce ihtiyaçlarınızın neler olduğunu belirlemeniz önemlidir.',
        'Hdi Sigorta tamamlayıcı sağlık sigortası ile müşterilerine sağlık hizmetlerini anlaşmalı özel hastanelerden almalarını sağlamaktadır.',
        'Sağlık sigortası planları Alokasko.com ile oldukça avantajlıdır - biz sadece onları bulmanızı kolaylaştırıyoruz!'
      ]
    },
    subContent: {
      title: 'HDI Sigorta Tamamlayıcı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası teminatları yatarak ve ayakta tedavi teminatlarını içermektedir.',
          subList: null
        },
        {
          paragraph:
            'Yatarak tedavi, hastanede 24 saati aşan yatış gerektiren tedavileri kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Ameliyat',
            'Hastanede tedavi',
            'Kemoterapi, Radyoterapi',
            'Oda / Yemek/ Refakatçi',
            'Acil ulaşım Ambulans',
            'Suni uzuv',
            'Tıbbi malzeme',
            'Evde Bakım'
          ]
        },
        {
          paragraph:
            'Ayakta tedavi, hastanede 24 saati aşmayan yatış gerektirmeyen tedavileri kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Ayakta Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Doktor Muayene',
            'Laboratuvar',
            'Görüntüleme',
            'Modern Teşhis ( MR, Tomografi vb.)',
            'Fizik Tedavi'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
